import { Box, Typography } from "@mui/material";
import dottedCircle from "../../assets/images/Component 129.svg";
import Circle from "../../assets/images/Ellipse 23448.svg";

const fontSizes = {
  edit: {
    xs: ["16px", "20px"],
    sm: ["18px", "22px"],
    md: ["20px", "24px"],
    lg: ["22px", "26px"],
    xl: ["26px", "30px"],
  },
  create: {
    xs: ["16px", "20px"],
    sm: ["18px", "22px"],
    md: ["20px", "24px"],
    lg: ["24px", "28px"],
    xl: ["28px", "32px"],
  },
};

export default function PlanCardHeader({
  pack,
  index,
  activeIndex,
  variant = "edit",
}) {
  const isActive = index === activeIndex;
  const sizes = fontSizes[variant] || fontSizes.edit;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: Object.fromEntries(
            Object.entries(sizes).map(([bp, [active, inactive]]) => [
              bp,
              isActive ? active : inactive,
            ]),
          ),
          fontWeight: 600,
          lineHeight: 1.6,
          letterSpacing: "0.0075em",
          margin: 0,
          color: isActive ? "#fff" : "#2A4876",
        }}
      >
        {pack?.name}
      </Typography>
      <img
        src={isActive ? dottedCircle : Circle}
        alt="status"
        style={{ width: 24, height: 24 }}
      />
    </Box>
  );
}
